export const formatters = {
  amounts: (value) => {
    return new Intl.NumberFormat("en", {
      notation: "compact",
      compactDisplay: "short",
      maximumFractionDigits: 1,
    }).format(value);
  },
  addresses: (address, startLength = 6, endLength = 5, separator = "•••••") => {
    if (!address || address.length <= startLength + endLength) return address;
    return `${address.slice(0, startLength)}${separator}${address.slice(
      -endLength
    )}`;
  },
};

export default formatters;
